import { withCompInfo } from '../../core/withCompInfo'
import { getCss, isMobileViewOrDevice } from '../DatePicker/DatePicker'
import { DatePickerCssCarmiData } from '../DatePicker/types'
import { DatePickerCalendarDefinition, DatePickerCalendarCSSVars } from './types'

export const css = withCompInfo<DatePickerCalendarCSSVars, DatePickerCalendarDefinition, DatePickerCssCarmiData>(
	[
		'skin',
		'compData',
		'compProps',
		'compLayout',
		'styleProperties',
		'isMobileView',
		'hasResponsiveLayout',
		'deviceType',
	],
	(
		{ skin, compData, compProps, compLayout, styleProperties, isMobileView, hasResponsiveLayout, deviceType },
		cssVars
	) => {
		const isMobile = isMobileViewOrDevice(isMobileView, deviceType)
		return {
			...getCss(
				{
					skin,
					compData,
					compProps,
					compLayout,
					styleProperties,
					isMobileView,
					hasResponsiveLayout,
					deviceType,
				},
				cssVars
			),
			width: isMobile ? '100%' : '320px',
			height: isMobile ? '100%' : 'auto',
		}
	}
)
